export default {
  title: {
    en: 'Before you go...',
  },
  text: {
    en: `Your payment hasn't been processed yet. Are you sure you want to leave the page?`,
  },
  stayButton: {
    en: 'Stay on page',
  },
  leaveButton: {
    en: 'Leave page',
  },
}
